import type { IconSvgObject } from './types';

const WifiUnlockIcon: IconSvgObject = [
  ["path", { d: "M8.5 15C9.63349 13.8665 11.0882 13.3754 12.5 13.5267", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5.5 11.5C8.51685 8.50559 11.7828 7.7405 15 9.26006", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 7.5C8.31579 2.16669 15.6842 2.16668 22 7.49989", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16.5 15H15V20.5H22V15H20.5H16.5ZM16.5 15V13.5C16.5 12.3954 17.3954 11.5 18.5 11.5C19.0973 11.5 19.6335 11.7619 20 12.1771", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default WifiUnlockIcon;
